<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户课程列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 添加 -->
    <el-form :inline="true" style="margin-top: 20px;">
      <el-form-item>
        <el-input size="small" v-model="sousuo.title" placeholder="请输入课程标题"></el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-select size="small" v-model="sousuo.type" placeholder="请选择课程类别">
          <el-option v-for="item in optionsS1" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="sousuo.free" placeholder="请选择费用类别">
          <el-option v-for="item in optionsS2" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="sousuo.currency" placeholder="请选择币种">
          <el-option v-for="item in optionsS4" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="审核状态">
        <el-select v-model="sousuo.status" placeholder="请选择审核状态">
          <el-option v-for="item in optionsS5" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openTask()">添加</el-button>
      </el-form-item> -->
    </el-form>

    <!-- 列表 -->
    <el-table size="small" :data="TaskData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;margin-top: 24px;" v-horizontal-scroll>
      <el-table-column align="center" prop="nickName" label="用户昵称" width="120"></el-table-column>
      <el-table-column align="center" prop="mobile" label="用户手机号" width="120"></el-table-column>
      <el-table-column align="center" prop="avatar" label="用户头像" width="120">
        <template slot-scope="scope">
          <el-image v-if="scope.row.avatar" style="width: 40px;height: 40px;" :src="scope.row.avatar"
            :preview-src-list="[scope.row.avatar]" />
          <div v-if="scope.row.avatar == null || scope.row.avatar == ''">没有图片</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="title" label="课程标题" width="120"></el-table-column>
      <el-table-column align="center" prop="description" label="课程描述" width="120"></el-table-column>

      <el-table-column align="center" prop="image" label="封面图" width="120">
        <template slot-scope="scope">
          <el-image v-if="scope.row.image" style="width: 90px;height: 90px;" :src="scope.row.image"
            :preview-src-list="[scope.row.image]" />
          <div v-if="scope.row.image == null || scope.row.image == ''">没有图片</div>
        </template>
      </el-table-column>

      <!-- <el-table-column align="center" prop="url" label="作品" width="120">
        <template slot-scope="scope">
          <template v-if="scope.row.type === 1">
            <video :src="scope.row.url" style="width: 80px;" v-if="scope.row.url" controls>
              Your browser does not support the video tag.
            </video>
            <div v-if="scope.row.url == null">没有视频</div>
          </template>
          <template v-else>
            <el-image v-for="(url, index) in scope.row.url.split(',')" :key="index" :src="url"
              style="margin-right: 5px; width: 90px;" :preview-src-list="[url]"></el-image>
            <div v-if="scope.row.url == null">没有图片</div>
          </template>
        </template>
      </el-table-column> -->
      <el-table-column align="center" prop="status" label="审核状态" width="120" :formatter="Status"></el-table-column>
      <!-- <el-table-column align="center" prop="type" label="课程类别" width="120" :formatter="Type"></el-table-column> -->
      <!-- <el-table-column align="center" prop="free" label="费用类别" width="120" :formatter="Free"></el-table-column> -->
      <!-- <el-table-column align="center" prop="currency" label="币种" width="120" :formatter="Currency"></el-table-column> -->
      <el-table-column align="center" prop="totalAmount" label="钻石总数量" width="120"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间" width="160">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="600" fixed="right">
        <template slot-scope="scope">
          <!-- <el-button size="mini" type="primary" @click="getUsers(scope.row)">查看参与列表</el-button> -->
          <el-button size="mini" type="primary" @click="getTaskxq(scope.row)">查看课程详情</el-button>
          <el-button size="mini" type="primary" @click="taskToVideo(scope.row)">查看视频详情</el-button>
          <el-button size="mini" type="primary" @click="btnOperate(scope.row)">审核</el-button>
          <!-- <el-button size="mini" type="primary" v-if="scope.row.status == 0 || scope.row.status == 2"
            @click="aduitTaskFn(scope.row, 1)">审核通过</el-button>
          <el-button size="mini" v-if="scope.row.status == 1" type="danger"
            @click="btnNotPass(scope.row)">审核不通过</el-button> -->
          <el-button size="mini" type="primary" @click="openTask(scope.row)">修改</el-button>
          <el-button size="mini" type="danger" @click="deleTask(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 课程详情 -->
    <el-dialog title="课程管理详情页：" :visible.sync="editFormDetails">
      <el-form label-width="120px">
        <el-form-item label="课程标题：">
          <span v-html="this.Details.title"></span>
        </el-form-item>
        <el-form-item label="课程描述：">
          <span v-html="this.Details.description" style="display: block; width: 100%"></span>
        </el-form-item>
        <el-form-item label="头像：">
          <el-image v-if="this.Details.avatar" style="width: 140px;margin-left: 14px;" :src="this.Details.avatar"
            :preview-src-list="[this.Details.avatar]" />
        </el-form-item>
        <el-form-item label="封面图：">
          <el-image v-if="this.Details.image" style="width: 140px;margin-left: 14px;" :src="this.Details.image"
            :preview-src-list="[this.Details.image]" />
          <span v-else>没有图片</span>
        </el-form-item>
        <!-- <el-form-item label="视频：">
          <video :src="this.Details.url" style="width: 140px;margin-left: 14px;" v-if="this.Details.url" controls>
            Your browser does not support the video tag.
          </video>
          <span v-else>没有视频</span>
        </el-form-item> -->
        <!-- <el-form-item label="课程类别：">
          <span v-if="this.Details.type == 0">图文</span>
          <span v-if="this.Details.type == 1">视频</span>
        </el-form-item> -->
        <!-- <el-form-item label="费用类别：">
          <span v-if="this.Details.free == 0">免费</span>
          <span v-if="this.Details.free == 1">收费</span>
          <span v-if="this.Details.free == 2">奖励</span>
        </el-form-item> -->
        <!-- <el-form-item label="币种：">
          <span v-if="this.Details.currency == 0">奖学金</span>
          <span v-if="this.Details.currency == 1">钻石</span>
        </el-form-item> -->
        <el-form-item label="钻石总数量：">
          <span v-html="this.Details.totalAmount"></span>
        </el-form-item>
        <el-form-item label="审核状态：">
          <span v-if="this.Details.status == 0">待审核</span>
          <span v-if="this.Details.status == 1">审核通过</span>
          <span v-if="this.Details.status == 2">审核中</span>
        </el-form-item>
        <el-form-item label="创建时间：" v-if="this.Details.createTime">
          {{ transformDate(this.Details.createTime) }}
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 编辑界面 -->
    <el-dialog :title="tit" :visible.sync="editFormVisiible" width="40%">
      <el-form label-width="120px">
        <el-form-item label="课程标题">
          <el-input size="small" v-model="title" auto-complete="off" placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input size="small" v-model="description" auto-complete="off" placeholder="请输入课程描述"></el-input>
        </el-form-item>
        <el-form-item label="封面图">
          <div style="display: flex; align-items: center;">
            <el-upload action="" :http-request="mainImgUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-image v-if="image" style="width: 140px;height:140px;margin-left: 14px;" :src="image"
              :preview-src-list="[image]" />
          </div>
        </el-form-item>
        <el-form-item label="课程类别">
          <el-select v-model="type" placeholder="请选择课程类别">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="视频" prop="url" v-if="type == 1">
          <div style="display: flex; align-items: center;">
            <el-upload action="" :http-request="mainVideoUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <video :src="url" style="width: 80px;margin-left: 14px;" v-if="url" controls>
              Your browser does not support the video tag.
            </video>
          </div>
        </el-form-item> -->
        <el-form-item label="费用类别">
          <el-select v-model="free" placeholder="请选择费用类别">
            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="币种">
          <el-select v-model="currency" placeholder="请选择币种">
            <el-option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="钻石数量" prop="amount">
          <el-input size="small" v-model="amount" auto-complete="off" placeholder="请输入钻石数量"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="审核状态">
          <el-select v-model="status" placeholder="请选择审核状态">
            <el-option v-for="item in options5" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="标签名">
          <el-select v-model="tagId" placeholder="请选择标签名">
            <el-option v-for="item in optionsTag" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input size="small" v-model="sort" auto-complete="off" placeholder="请输入排序"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog()'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="addTask()" v-if="tit == '添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="upTask()" v-if="tit == '修改'">修改</el-button>
      </div>
    </el-dialog>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 审核不通过原因 -->
    <el-dialog title="审核不通过" :visible.sync="reasonVisible" width="40%" >

      <el-input type="textarea" :rows="5" placeholder="请输入审核不通过原因" v-model="notReason">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="reasonVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="btnSubmitReason">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import {
  getTaskList,
  getTaskInfo,
  addTask,
  aduitTask,
  deleteTask,
  upTask,
  getTaskTagList,
  getUserListByTaskId
} from '../../api/userMG'
import client from "@/utils/ossClient.js";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      optionsS1: [
        {
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '图文'
        }, {
          value: 1,
          label: '视频'
        }],
      optionsS2: [
        {
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '免费'
        }, {
          value: 1,
          label: '收费'
        }, {
          value: 2,
          label: '奖励'
        }],
      optionsS4: [
        {
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '奖学金'
        }, {
          value: 1,
          label: '钻石'
        }],
      optionsS5: [
        {
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '待审核'
        }, {
          value: 1,
          label: '审核通过'
        }, {
          value: 3,
          label: '审核中'
        }],
      TaskData: [],
      sousuo: {
        title: '',
        type: -1,
        free: -1,
        currency: -1,
        status: -1,
        mobile: '',
        nickName: ''
      },
      title: '',
      description: '',
      image: '',
      url: '',
      type: '',
      free: '',
      kind: 1,
      currency: '',
      amount: '',
      tagId: '',
      sort: '',
      mobile: '',
      nickName: '',
      status: '',
      editFormDetails: false,
      Details: [],
      editFormVisiible: false,
      options1: [{
        value: 0,
        label: '图文'
      }, {
        value: 1,
        label: '视频'
      }],
      options2: [{
        value: 0,
        label: '免费'
      }, {
        value: 1,
        label: '收费'
      }, {
        value: 2,
        label: '奖励'
      }],
      options4: [{
        value: 0,
        label: '奖学金'
      }, {
        value: 1,
        label: '钻石'
      }],
      options5: [{
        value: 0,
        label: '待审核'
      }, {
        value: 1,
        label: '审核通过'
      }, {
        value: 3,
        label: '审核中'
      }],
      tit: '添加',
      optionsTag: [],
      editFormUsers: false,
      canYu: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },
      reasonVisible: false,
      notReason: '', // 不通过原因
      temporary_obj: '', // 临时数据
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  created() {
    this.getData(1)
    this.gteTag()
  },
  methods: {
    // 分页插件事件
    callFather(parm) {
      this.pageparm.page = parm.currentPage
      this.getdata(parm.currentPage)
    },
    // 查询课程参与用户列表
    getUsers(row) {
      this.loading = true;
      this.editFormUsers = true;
      let data = {
        id: row.id,
        page: 0
      }
      getUserListByTaskId(data).then((res) => {
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg
          });
        } else {
          this.canYu = res.data.data;
          return;
        }
      })
    },
    // 跳转页面
    taskToVideo(row) {
      setTimeout(() => {
        this.loading = false
        // 跳转页面
        this.$router.push({
          path: '/task/TaskToVideo', query: {
            id: row.id
          }
        })
      })
    },
    // 搜索数据
    search() {
      this.getData(1)
    },
    // 重置数据
    chongzhi() {
      this.sousuo.title = ''
      this.sousuo.type = -1
      this.sousuo.free = -1
      this.sousuo.currency = -1
      this.sousuo.status = -1
      this.getData(1)
    },
    // 获取标签列表
    gteTag() {
      getTaskTagList().then((res) => {
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg,
          });
        } else {
          res.data.list.forEach((item) => {
            this.optionsTag.push({ label: item.name, value: item.id })
          })
          return;
        }
      })
    },
    // 关闭编辑对话框
    closeDialog() {
      this.editFormVisiible = false
      this.$message({
        type: 'info',
        message: '已取消编辑'
      })
    },
    // 修改
    upTask() {
      this.loading = true,
        upTask({
          id: this.id,
          title: this.title,
          description: this.description,
          image: this.image,
          url: this.url,
          type: this.type,
          free: this.free,
          kind: 1,
          currency: this.currency,
          amount: this.amount,
          status: this.status,
          tagId: this.tagId,
          sort: this.sort,
          createTime: this.createTime,
        }).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.editFormVisiible = false
            this.$message.success(res.msg)
            this.getData(1)
          } else {
            this.editFormVisiible = false
            this.$message.error(res.msg);
          }
        })
    },

    // 添加
    addTask() {
      this.loading = true,
        addTask({
          title: this.title,
          description: this.description,
          image: this.image,
          url: this.url,
          type: this.type,
          free: this.free,
          kind: 1,
          currency: this.currency,
          amount: this.amount,
          status: this.status,
          tagId: this.tagId,
          sort: this.sort,
          createTime: '',
          updateTime: ''
        }).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.editFormVisiible = false
            this.$message.success(res.msg)
            this.getData(1)
          } else {
            this.editFormVisiible = false
            this.$message.error(res.msg);
          }
        })
    },
    // 打开编辑页
    openTask(row) {
      this.editFormVisiible = true;
      if (row != undefined && row != "undefined") {
        this.tit = "修改";
        this.id = row.id;
        this.title = row.title;
        this.description = row.description;
        this.image = row.image;
        this.url = row.url;
        this.type = row.type;
        this.free = row.free;
        this.currency = row.currency;
        this.amount = row.amount;
        this.status = row.status;
        this.tagId = row.tagId;
        this.sort = row.sort;
        this.createTime = row.createTime;
      } else {
        this.tit = "添加";
        this.title = "";
        this.description = "";
        this.image = "";
        this.url = "";
        this.type = "";
        this.free = "";
        this.currency = "";
        this.amount = "";
        this.status = "";
        this.tagId = "";
        this.sort = "";
        this.createTime = "";
      }
    },
    // 删除课程
    deleTask(row) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        let data = {
          id: row.id
        }
        deleteTask(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getData(1)
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 点击审核不通
    btnNotPass(item) {
      this.temporary_obj = item
      this.reasonVisible = true
    },
    // 提交审核不通过
    btnSubmitReason() {
      let that = this
      if (!that.notReason) {
        this.$message({
          type: 'info',
          message: '请输入不通过原因'
        });
        return false;
      }
      this.$confirm('确定当前操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        let data = {
          id: that.temporary_obj.id,
          status: 2,
          remark: that.notReason, // 不通过原因

        }
        aduitTask(data).then(res => {
          if (res.code == 200) {
            this.reasonVisible = false
            this.$message.success(res.msg)
            this.getData(-1)
          } else {
            this.reasonVisible = false
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 自定义上传方法 图片的
    mainImgUpload(file) {
      // 判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            this.image = res.url
            // this.image.push(res.url)
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },
    // 自定义上传方法 视频的
    mainVideoUpload(file) {
      // 判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["video", "mp4"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            this.url = res.url
            // this.image.push(res.url)
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },

    // 查看详情页面
    getTaskxq(row) {
      this.loading = true;
      this.editFormDetails = true;
      let data = {
        id: row.id
      }
      //   return console.log("idudddd",data.id);
      getTaskInfo(data).then((res) => {
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg
          });
        } else {
          this.Details = res.data.data;
          return;
        }
      })
    },
    // Status审核状态
    Status: function (row) {
      if (row.status == 0) {
        return " 待审核"
      } else if (row.status == 1) {
        return "审核通过"
      } else if (row.status == 2) {
        return "审核中"
      }
    },
    // Currency币种
    Currency: function (row) {
      if (row.currency == 0) {
        return "奖学金"
      } else if (row.currency == 1) {
        return "钻石"
      }
    },
    // kind发布类别
    Kind: function (row) {
      if (row.kind == 0) {
        return "平台"
      } else if (row.kind == 1) {
        return "个人"
      }
    },
    // free费用类别
    Free: function (row) {
      if (row.free == 0) {
        return "免费"
      } else if (row.free == 1) {
        return "收费"
      } else if (row.free == 2) {
        return "奖励"
      }
    },
    // Type课程类别
    Type: function (row) {
      if (row.type == 0) {
        return "图文"
      } else if (row.type == 1) {
        return "视频"
      }
    },
    // 获取数据
    getData(page) {
      this.loading = true;
      let data = {
        title: this.sousuo.title,
        type: this.sousuo.type,
        free: this.sousuo.free,
        kind: 1,
        currency: this.sousuo.currency,
        status: this.sousuo.status,
        mobile: this.sousuo.mobile,
        nickName: this.sousuo.nickName,
        page: (page - 1) * 10,
      }
      getTaskList(data).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.TaskData = res.data.list;
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          return;
        } else {
          this.$Message({
            type: "info",
            message: res.msg
          })
        }
      })
    },
    aduitTaskFn(row, status) {
      this.$confirm('确定当前操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        let data = {
          id: row.id,
          status
        }
        aduitTask(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getData(1)
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 操作按钮
    btnOperate(item) {
      let that = this
      this.$confirm('是否审核通过！', '提示', {
        confirmButtonText: '通过',
        cancelButtonText: '不通过',
        distinguishCancelAndClose: true,
        type: 'success'
      }).then((res) => {
        console.log('通过', res)
        that.aduitTaskFn(item,1)
      }).catch(action => {
        if (action === 'cancel') {
          that.temporary_obj = item
          that.reasonVisible = true
          
        }else{
          console.log('关闭')
        }
      });
    }

  }

}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/task/Task.vue